import { Skeleton } from "src/design-system/Skeleton";

// Placeholder tiles mirroring the chart grid while the dashboard loads.
const PLACEHOLDER_TILES = [
  { key: "a", width: 3, height: 3 },
  { key: "b", width: 3, height: 3 },
  { key: "c", width: 4, height: 3 },
  { key: "d", width: 2, height: 3 },
];

// Mirrors DashboardChartCard's chrome so the placeholders read as cards (white
// surface, border, header bar) rather than borderless gray-on-gray blocks.
export const DashboardGridSkeleton: React.FC = () => (
  <div
    className="decideScrollbar h-full overflow-y-auto"
    data-loc="dashboard-grid-skeleton"
  >
    <div className="grid auto-rows-[100px] grid-cols-6 gap-4 p-4">
      {PLACEHOLDER_TILES.map((tile) => (
        <div
          key={tile.key}
          className="flex min-h-0 flex-col rounded-md border border-gray-200 bg-white"
          style={{
            gridColumn: `span ${tile.width}`,
            gridRow: `span ${tile.height}`,
          }}
        >
          <div className="border-gray-200 border-b px-4 py-3">
            <Skeleton height="h-4" width="w-1/3" />
          </div>
          <div className="min-h-0 flex-1 p-4">
            <Skeleton height="h-full" rounded="rounded-lg" width="w-full" />
          </div>
        </div>
      ))}
    </div>
  </div>
);
